import { Box, GlobalStyles } from '@mui/material';

// Blue-toned glow gradient (Medium Slate Blue → Electric Sapphire). Shared by
// the auth screen and the signed-in app so both keep the same backdrop.
const GLOW_GRADIENT = 'linear-gradient(45deg, #8966E1 0%, #6271F8 100%)';

export interface AtmosphericGlowProps {
  /** Stacking context for the glow. Defaults to 0. */
  zIndex?: number | string;
  /** Adds the auth screen's slow breathing animation. */
  animate?: boolean;
}

// Fixed, mostly-offscreen ellipse rising from the bottom of the viewport.
export function AtmosphericGlow({ zIndex = 0, animate = false }: AtmosphericGlowProps) {
  return (
    <>
      {animate && (
        <GlobalStyles
          styles={{
            '@keyframes ariAuroraBottom': {
              '0%,100%': { transform: 'translateX(-50%) translateY(72%) scale(1)' },
              '50%': { transform: 'translateX(-50%) translateY(69%) scale(1.07)' },
            },
          }}
        />
      )}
      <Box
        aria-hidden
        sx={{
          position: 'fixed',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%) translateY(72%)',
          width: { xs: '185vw', sm: '130vw' },
          height: { xs: '62vh', sm: '85vh' },
          borderRadius: '50%',
          background: GLOW_GRADIENT,
          opacity: 0.2,
          filter: { xs: 'blur(110px)', sm: 'blur(170px)' },
          pointerEvents: 'none',
          zIndex,
          ...(animate && {
            willChange: 'transform',
            animation: 'ariAuroraBottom 20s cubic-bezier(0.23, 1, 0.32, 1) infinite',
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }),
        }}
      />
    </>
  );
}
